import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/i18n";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
  const { t } = useI18n();

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative bg-black py-28 md:py-40"
    >
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-[1fr_2fr] gap-16">
          <div>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8 }}
              className="flex items-center gap-3 mb-8"
            >
              <span className="w-10 h-px bg-lux" />
              <span className="text-[11px] uppercase tracking-[0.3em] text-lux">
                {t.faq.label}
              </span>
            </motion.div>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9 }}
              className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter text-balance"
            >
              {t.faq.title}
            </motion.h2>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.1 }}
          >
            <Accordion type="single" collapsible className="w-full">
              {t.faq.items.map((it, i) => (
                <AccordionItem
                  value={`item-${i}`}
                  key={i}
                  data-testid={`faq-${i}`}
                  className="border-b border-white/10 py-2"
                >
                  <AccordionTrigger className="text-left font-display text-lg md:text-xl font-light tracking-tight hover:no-underline text-white">
                    {it.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-white/60 text-[15px] leading-relaxed pr-6">
                    {it.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
